const getters = {
  listaMotivosRestricoesArquivo: (state) => state.listaMotivosRestricoesArquivo,
  listaArquivos: (state) => state.listaArquivos,
  listaPecas: (state) => state.listaPecas,
  listaDocumentos: (state) => state.listaDocumentos,
  listaArquivosAssinadosNaoVinculados: (state) => state.listaArquivosAssinadosNaoVinculados,
  arquivo: (state) => state.arquivo,
  arquivoBlobURL: (state) => state.arquivoBlobURL,
  arquivoEdicaoDialog: (state) => state.arquivoEdicaoDialog,
  cancelamentoPecaDialog: (state) => state.cancelamentoPecaDialog,
  adicionarArquivoAssinadoDialog: (state) => state.adicionarArquivoAssinadoDialog,
  informacoesPecasUploadDialog: (state) => state.informacoesPecasUploadDialog,
  passoAtual: (state) => state.passoAtual,
  situacaoVinculo: (state) => state.situacaoVinculo,
  documentoSelecionado: (state) => state.documentoSelecionado,
  justificativaCancelamento: (state) => state.justificativaCancelamento
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/arquivos-documento/getters.js